export const GLOBAL_CONFIG = {
    host: '',
    GSPL_BASE_URL: '',
    GSPL_API_KEY: '',
    COMPANY_MIN_LENGTH: '',
    COMPANY_MAX_LENGTH: '',
    NAME_MIN_LENGTH: '',
    NAME_MAX_LENGTH: '',
    ADDRESS_LENGTH: '',
    POSTAL_CODE_LENGTH: '',
    CITY_LENGTH: '',
    PHONE_LENGTH: '',
    EMAIL_LENGTH: '',
    PARCELS_COUNT: '',
    PARCEL_MIN_WEIGHT: '',
    PARCEL_MAX_WEIGHT: '',
    PARCEL_MIN_WIDTH: '',
    PARCEL_MAX_WIDTH: '',
    PARCEL_MIN_DEPTH: '',
    PARCEL_MAX_DEPTH: '',
    PARCEL_MIN_HEIGHT: '',
    PARCEL_MAX_HEIGHT: '',
    MIN_DECLARED_VALUE: '',
    MAX_DECLARED_VALUE: '',
    CONTENT_LENGTH: '',
    MIN_CUSTOMS_EORI_LENGTH: '',
    MAX_CUSTOMS_EORI_LENGTH: '',
    MIN_CUSTOMS_VAT_LENGTH: '',
    MAX_CUSTOMS_VAT_LENGTH: '',
    MAX_CUSTOMS_ITEM_DESCRIPTION_LENGTH: '',
    MAX_CUSTOMS_ITEM_COMMODITY_CODE_LENGTH: '',
    SPECIAL_INSTRUCTIONS_LENGTH: '',
    EXTENDED_LIABILITY_AVAILABLE_SERVICE_CODES: '',
    INCOMPATIBLE_SMART_OPTION_SERVICE_POINT_CODES: ''
};

export function getMainDataset() {
    const main = document.querySelector('main');
    return main?.dataset || {};
}

export function getCspNonce() {
    const dataset = getMainDataset();
    return dataset?.cspNonce || '';
}

export function initConstantsFromMainDataset(constantsMap) {
    const mainDataset = getMainDataset();
    if (!mainDataset) {
        console.warn('Impossible d’initialiser les constantes : dataset de main introuvable.');
        return;
    }

    GLOBAL_CONFIG.host = mainDataset.host;
    GLOBAL_CONFIG.PARCEL_MIN_WEIGHT = mainDataset.parcelMinWeight || '';
    GLOBAL_CONFIG.PARCEL_MAX_WEIGHT = mainDataset.parcelMaxWeight || '';
    GLOBAL_CONFIG.PARCEL_MIN_WIDTH = mainDataset.parcelMinWidth || '';
    GLOBAL_CONFIG.PARCEL_MAX_WIDTH = mainDataset.parcelMaxWidth || ''
    GLOBAL_CONFIG.PARCEL_MIN_DEPTH = mainDataset.parcelMinDepth || ''
    GLOBAL_CONFIG.PARCEL_MAX_DEPTH = mainDataset.parcelMaxDepth || ''
    GLOBAL_CONFIG.PARCEL_MIN_HEIGHT = mainDataset.parcelMinHeight || ''
    GLOBAL_CONFIG.PARCEL_MAX_HEIGHT = mainDataset.parcelMaxHeight || ''
    GLOBAL_CONFIG.PARCELS_COUNT = mainDataset.parcelsCount || ''
    GLOBAL_CONFIG.CITY_LENGTH = mainDataset.cityLength || ''
    GLOBAL_CONFIG.POSTAL_CODE_LENGTH = mainDataset.postalCodeLength || ''
    GLOBAL_CONFIG.COMPANY_MIN_LENGTH = mainDataset.companyMinLength || ''
    GLOBAL_CONFIG.COMPANY_MAX_LENGTH = mainDataset.companyMaxLength || ''
    GLOBAL_CONFIG.NAME_MIN_LENGTH = mainDataset.nameMinLength || ''
    GLOBAL_CONFIG.NAME_MAX_LENGTH = mainDataset.nameMaxLength || ''
    GLOBAL_CONFIG.ADDRESS_LENGTH = mainDataset.addressLength || ''
    GLOBAL_CONFIG.PHONE_LENGTH = mainDataset.phoneLength || ''
    GLOBAL_CONFIG.EMAIL_LENGTH = mainDataset.emailLength || ''
    GLOBAL_CONFIG.MIN_DECLARED_VALUE = mainDataset.minDeclaredValue || ''
    GLOBAL_CONFIG.MAX_DECLARED_VALUE = mainDataset.maxDeclaredValue || ''
    GLOBAL_CONFIG.CONTENT_LENGTH = mainDataset.contentLength || ''
    GLOBAL_CONFIG.MIN_CUSTOMS_EORI_LENGTH = mainDataset.minCustomsEoriLength || ''
    GLOBAL_CONFIG.MAX_CUSTOMS_EORI_LENGTH = mainDataset.maxCustomsEoriLength || ''
    GLOBAL_CONFIG.MIN_CUSTOMS_VAT_LENGTH = mainDataset.minCustomsVatLength || ''
    GLOBAL_CONFIG.MAX_CUSTOMS_VAT_LENGTH = mainDataset.maxCustomsVatLength || ''
    GLOBAL_CONFIG.MAX_CUSTOMS_ITEM_DESCRIPTION_LENGTH = mainDataset.maxCustomsItemDescriptionLength || ''
    GLOBAL_CONFIG.MAX_CUSTOMS_ITEM_COMMODITY_CODE_LENGTH = mainDataset.maxCustomsItemCommodityCodeLength || ''
    GLOBAL_CONFIG.SPECIAL_INSTRUCTIONS_LENGTH = mainDataset.specialInstructionsLength || ''
    GLOBAL_CONFIG.GSPL_BASE_URL = mainDataset.gsplBaseUrl || '';
    GLOBAL_CONFIG.GSPL_API_KEY = mainDataset.gsplApiKey || '';
    GLOBAL_CONFIG.EXTENDED_LIABILITY_AVAILABLE_SERVICE_CODES = mainDataset.extendedLiabilityAvailableServiceCodes || '';
    GLOBAL_CONFIG.INCOMPATIBLE_SMART_OPTION_SERVICE_POINT_CODES = mainDataset.incompatibleSmartOptionServicePointCodes || '';
}
